"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateOrderNumber = void 0;
var calculateOrderNumber = function (currentIndex, count) {
    currentIndex += 1;
    var COLUMNS = 2;
    var rowCounts = Math.floor(count / COLUMNS);
    if (currentIndex % 2 === 0)
        return currentIndex / COLUMNS;
    else
        return Math.ceil(currentIndex / COLUMNS) + rowCounts;
};
exports.calculateOrderNumber = calculateOrderNumber;
